import React from "react";
import { X } from "lucide-react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import ModalWrapper from "../Modal";
import { getErrorMessage } from "../../utils/getErrorMessage";
import { deleteCategory } from "../../services/categoryService";

const DeleteCategoryModal = ({
  isOpen,
  onClose,
  onDelete,
  category,
  onDeleteSuccess,
}) => {
  const queryClient = useQueryClient();

  const { mutate: handleDelete, isPending } = useMutation({
    mutationFn: () => deleteCategory(category.id),
    onSuccess: () => {
      toast.success("Category deleted successfully!");
      onClose();
      if (onDeleteSuccess) onDeleteSuccess();
      if (onDelete) onDelete();
      queryClient.invalidateQueries({ queryKey: ["categories"] });
    },
    onError: (error) => {
      toast.error(getErrorMessage(error, "Failed to delete category."));
    },
  });

  return (
    <ModalWrapper isOpen={isOpen} onClose={onClose}>
      <div className="w-full max-w-[480px] sm:rounded-2xl rounded-none sm:mx-0 mx-0 sm:my-0 my-0 sm:p-0 p-0 relative">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute -top-2 right-4 text-gray-[#4F535D] hover:text-gray-600 transition-colors"
        >
          <X size={24} />
        </button>
        {/* Header Icon */}
        <div className="mt-[22px] mb-6 flex justify-center">
          <img
            src="/images/icons/delete-product.svg"
            alt="delete"
            className="h-16 w-16"
          />
        </div>
        {/* Text Content */}
        <div className="mb-8 text-center px-2 sm:px-0">
          <h2 className="mb-3 text-2xl font-semibold text-[#0C0C0E]">
            Confirm Delete
          </h2>
          <p className="text-base text-[#7D828D] font-medium">
            Are you sure you want to delete category <br />
            <span className="font-medium text-[#0C0C0E]">{category.name}</span>?
          </p>
        </div>
        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 px-2 sm:px-0">
          <button
            onClick={() => handleDelete()}
            disabled={isPending}
            className="flex-1 rounded-lg h-10 bg-[#DB0003] py-2 text-base font-medium text-white transition-all hover:bg-red-700 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isPending ? "Deleting..." : "Delete"}
          </button>
          <button
            onClick={onClose}
            className="flex-1 rounded-lg h-10 border border-gray-200 bg-white py-2 text-base font-medium text-gray-700 transition-all hover:bg-gray-50 active:scale-95"
          >
            Cancel
          </button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default DeleteCategoryModal;
